import React from "react";
import { useTranslation } from "react-i18next";

export const StatsStrip = () => {
  const { t } = useTranslation();
  const items = t("stats.items", { returnObjects: true }) || [];

  return (
    <section
      className="section-wash border-b border-border"
      data-testid="home-stats-strip"
    >
      <div className="container-page py-14 sm:py-16">
        <div className="max-w-3xl">
          <h2 className="text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">
            {t("stats.title")}
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-muted-foreground sm:text-base">
            {t("stats.lead")}
          </p>
        </div>

        <div className="hairline-grid mt-8 grid grid-cols-1 gap-px overflow-hidden rounded-xl border border-border sm:grid-cols-2 lg:grid-cols-4">
          {items.map((item, index) => (
            <div
              key={item.label}
              className="bg-card p-5"
              data-testid={`stat-item-${index}`}
            >
              <p className="font-data text-[10px] uppercase leading-relaxed tracking-[0.14em] text-[hsl(var(--ink-3))]">
                {item.label}
              </p>
              <p
                className="font-data mt-3 text-2xl font-semibold text-foreground sm:text-[28px]"
                data-testid={`stat-value-${index}`}
              >
                {item.value}
              </p>
              <p className="mt-1 text-xs font-medium text-[hsl(var(--terracotta))]">
                {item.unit}
              </p>
              <p className="mt-3 border-t border-border pt-3 text-[11px] leading-relaxed text-muted-foreground">
                {item.note}
              </p>
            </div>
          ))}
        </div>

        <p className="mt-4 text-[11px] leading-relaxed text-muted-foreground">
          {t("stats.footnote")}
        </p>
      </div>
    </section>
  );
};

export default StatsStrip;
